import FormsBaseField from "./forms-base-field.vue";
import FormsCheckboxField from "../forms-checkbox-field.vue";

export default {
	mixins: [
		FormsBaseField
	],
	components: {
		FormsCheckboxField
	},
	data() {
		return {
			innerFields: [],
			innerUserInput: []
		}
	},
	watch: {
		userInput() {
			this.validateField();

			this.updateState(state => state.userInput = this.userInput);
		}
	},
	methods: {
		getRawInnerUserInput() {
			return JSON.stringify(this.innerUserInput);
		},
		onInnerFieldStateUpdate(innerField) {
			const initialInnerUserInput = this.getRawInnerUserInput();

			if (innerField.state.userInput) {
				if (!this.innerUserInput.includes(innerField.fieldValue)) {
					this.innerUserInput.push(innerField.fieldValue);
				}
			} else {
				this.innerUserInput = this.innerUserInput.filter(fieldValue => fieldValue !== innerField.fieldValue);
			}

			if (initialInnerUserInput !== this.getRawInnerUserInput()) {
				this.userInput = this.innerUserInput.join(',');
			}
		}
	}
};